import React from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const Parchment = ReactQuill.Quill.import('parchment')
// line-height
const lineHeightConfig = {
    scope: Parchment.Scope.INLINE,
    whitelist: ['1', '1.2', '1.5', '1.6', '1.8', '2', '2.4', '2.8'],
}
const lineHeightClass = new Parchment.Attributor.Class('lineheight', 'ql-line-height', lineHeightConfig)
const lineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightConfig)
Parchment.register(lineHeightClass)
Parchment.register(lineHeightStyle)
// font-size
const fontSizeConfig = {
    scope: Parchment.Scope.INLINE,
    whitelist: [
        '8px',
        '9px',
        '10px',
        '11px',
        '12px',
        '14px',
        '16px',
        '18px',
        '20px',
        '24px',
        '30px',
        '36px',
        '48px',
        '60px',
        '72px',
        '96px',
    ],
}
const fontSizeClass = new Parchment.Attributor.Class('fontsize', 'ql-font-size', fontSizeConfig)
const fontSizeStyle = new Parchment.Attributor.Style('fontsize', 'font-size', fontSizeConfig)
Parchment.register(fontSizeClass)
Parchment.register(fontSizeStyle)

const // To add a new font:
    // 1. Add font into this array
    // 2. Add classes as UpperCamelCase in rmx-text_editor.css
    fonts = [
        'Roboto',
        'Roboto Condensed',
        'Open Sans',
        'Open Sans Condensed',
        'Lato',
        'Montserrat',
        'Oswald',
        'Merriweather',
        'Ubuntu',
        'Lobster',
        'Pacifico',
        'Vollkorn',
        'Cuprum',
        'Alegreya Sans',
        'Russo One',
        'Playfair Display SC',
        'Alice',
        'Press Start 2P',
        'Bad Script',
        'Yeseva One',
        'Marmelad',
        'Rubik Mono One',
        'Raleway',
        'Roboto Slab',
        'Lora',
        'Seymour One',
        'Cormorant SC',
        'Literata',
        'Spectral',
        'Alegreya',
        'EB Garamond',
        'Bitter',
        'PT Serif',
        'Noto Sans',
    ],
    importedFonts = {
        // 'Ubuntu': true | false
        // ...
    }

const Font = ReactQuill.Quill.import('formats/font')
Font.whitelist = fonts.map(f => f.replace(/ /g, ''))
ReactQuill.Quill.register(Font, true)

const toolbar = [
    [{ font: Font.whitelist }, { fontsize: fontSizeConfig.whitelist }],
    ['bold', 'italic', 'underline', { color: [] }, { background: [] }],
    [{ align: [] }, { lineheight: lineHeightConfig.whitelist }],
    [{ list: 'ordered' }, { list: 'bullet' }],
]

const savedFormats = ['font', 'fontsize', 'bold', 'italic', 'underline', 'color', 'background', 'lineheight']

function addFont(family) {
    if (!importedFonts[family]) {
        const link = document.createElement('link')
        link.href = `https://fonts.googleapis.com/css2?family=${family}:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap`
        link.rel = 'stylesheet'
        document.getElementsByTagName('head')[0].append(link)
        importedFonts[family] = true
    }
}

class Text extends React.Component {
    reactQuillRef = React.createRef()

    constructor(props) {
        super(props)
        this.state = {
            focused: false,
            lastFormat: {},
        }
    }

    componentDidMount() {
        fonts.forEach(f => addFont(f))
    }

    onFocus = async evt => {
        const elem = evt.target
        const parent = elem.parentElement
        if (elem.getAttribute('data-mode') !== 'link' && parent.getAttribute('data-mode') !== 'link') {
            const lastFormat = this.reactQuillRef.current.getEditor().getFormat()
            this.setState({ lastFormat })
        }
        const { focused } = this.state
        if (!focused) {
            await this.setState({
                focused: true,
            })
            this.reactQuillRef.current.getEditor().focus()
        }
    }

    onBlur = () => {
        this.setState({
            focused: false,
        })
    }

    handleChange = html => {
        if (this.reactQuillRef.current) {
            const { onUpdate, id, propName } = this.props
            const editor = this.reactQuillRef.current.getEditor()
            if (editor.getText().length > 1) {
                const lastFormat = editor.getFormat()
                this.setState({ lastFormat })
            } else {
                const { lastFormat } = this.state
                savedFormats.forEach(format => {
                    if (lastFormat[format] !== undefined) {
                        editor.format(format, lastFormat[format])
                    }
                })
            }

            onUpdate({
                [id]: {
                    data: { [propName || 'text']: html },
                },
            })
        }
    }

    render() {
        const { text, withLink = true } = this.props
        const { focused } = this.state
        return (
            <OutsideClickHandler onOutsideClick={this.onBlur}>
                <div className={`qt${!focused ? ' __readonly' : ''}`} onClick={this.onFocus}>
                    <ReactQuill
                        readOnly={!focused}
                        modules={{
                            toolbar: [...toolbar, withLink ? ['link', 'clean'] : ['clean']],
                        }}
                        defaultValue={text}
                        onChange={this.handleChange}
                        ref={this.reactQuillRef}
                    />
                </div>
            </OutsideClickHandler>
        )
    }
}

export default Text
